const API_BASE = process.env.REACT_APP_API_BASE_URL?.replace(/\/$/, "");

if (!API_BASE) {
  throw new Error("REACT_APP_API_BASE_URL is missing. Check your .env file.");
}

export const apiFetch = async (endpoint, options = {}) => {
  const headers = {
    Accept: "application/json",
    ...(options.body ? { "Content-Type": "application/json" } : {}),
    ...options.headers,
  };

  const res = await fetch(`${API_BASE}${endpoint}`, {
    
    ...options,
    headers,
  });

  if (!res.ok) {
    let message = "API Error";
    try {
      const data = await res.json();
      message = data.error || data.message || message;
    } catch {
      /* ignore */
    }
    throw new Error(message);
  }

  if (res.status === 204) return null;

  return res.json();
};
